import { createI18n } from 'vue-i18n';
import fr from './locales/fr';
import en from './locales/en';

// Fonction pour détecter la langue initiale
function getInitialLocale(): string {
  // D'abord, vérifier s'il y a une préférence sauvegardée dans localStorage
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale && ['fr', 'en'].includes(savedLocale)) {
    return savedLocale;
  }
  
  // Sinon, utiliser la langue du navigateur
  const browserLocale = navigator.language.substring(0, 2);
  if (['fr', 'en'].includes(browserLocale)) {
    return browserLocale;
  }
  
  // Par défaut, français
  return 'fr';
}

const i18n = createI18n({
  legacy: false, // Pour utiliser l'API Composition
  locale: getInitialLocale(),
  fallbackLocale: 'fr',
  messages: {
    fr,
    en
  }
});

// Fonction pour synchroniser la langue avec le serveur
export function syncLocaleWithServer(serverLocale: string) {
  if (['fr', 'en'].includes(serverLocale) && i18n.global.locale.value !== serverLocale) {
    i18n.global.locale.value = serverLocale;
    localStorage.setItem('locale', serverLocale);
  }
}

export default i18n;
